import { render, staticRenderFns } from "./CandidateTenure.vue?vue&type=template&id=32b7db52&"
import script from "./CandidateTenure.vue?vue&type=script&lang=js&"
export * from "./CandidateTenure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports